import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import '../Tabs.css';
import 'rsuite/DatePicker/styles/index.css';
import { handleErrors, request } from '../utils/ApiUtils';
import Table from './Table';
import { formatToBRL } from '../utils/MonetaryUtils';
import Loading from './Loading';
import { getStatusBadgeStyle } from '../utils/StatusStyleUtils';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';

function BalancoFinanceiroReceitasTab(props) {
    const [loading, setLoading] = useState({loading: false});
    const [dataArray, setDataArray] = useState([]);
    const [receitas, setReceitas] = useState([]);
    const [fetchListError, setFetchListError] = useState();

    const carregarDados = async (page = 0) => {
        if (props.ano && props.mes) {
            setLoading({loading: true});

            request(`balanco-financeiro/receitas/${props.mes}/${props.ano}`, {
                type: 'GET',
                callback: (data) => (
                    setDataArray(data.content),
                    setReceitas(data)
                ),
                finally: () => setLoading({loading: false}),
                callbackError: (responseData, message) => {
                    handleErrors(responseData, 'Falha ao consultar receitas, por favor, atualize a tela ou tente novamente.  \n' + message, {setFetchListError});
                }
            })
        }
    };

    useEffect(() => { carregarDados(); }, [props.refreshKey]);

    const footerTotals = () => (
        <div style={{ paddingTop: '20px' }}>
            <h4 style={{ color: 'green', paddingBottom: '5px' }}>{`Valor total recebido: ${formatToBRL(receitas?.valorTotalRecebido)}`}</h4>
            <h4 style={{ color: 'orange' }}>{`Valor total a receber: ${formatToBRL(receitas?.valorTotalAReceber)}`}</h4>
        </div>
    );

    const tableParams = {
        query: (page) => carregarDados(page),
        // hasFooter: true,
        columns: [
            {
                label: "Cliente",
                width: "30%",
                type: "input",
                disable: true,
                key: "cliente"
            },
            {
                label: "Nº Parcela",
                width: "10%",
                type: "input",
                disable: true,
                key: "numeroParcela"
            },
            {
                label: "Valor Parcela",
                width: "18%",
                widthValue: '80%',
                disabled: true,
                type: "input-decimal",
                css: "decimal",
                key: "valor"
            },
            {
                label: "Data Vencimento",
                width: "15%",
                // widthValue: '100%',
                type: "date",
                disabled: true,
                key: "dataVencimento"
            },
            {
                label: "Status parcela",
                width: "12%",
                type: "input",
                css: "status-badge",
                disable: true,
                style: (item) => (
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                        ),
                key: "status",
                // footer: { startColumn: 3, colSpan: 2 },
                // htmlFooter: () => footerTotals()
            }
        ]
    };

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <div className="receitas-summary" aria-label="Resumo das receitas">
                <section className="receitas-summary-card receitas-summary-card-received">
                    <span className="receitas-summary-label">Recebido</span>
                    <strong>{formatToBRL(receitas?.valorTotalRecebido)}</strong>
                    <span className="receitas-summary-description">
                        <CheckCircleOutlineIcon aria-hidden="true" />
                        Valores já recebidos
                    </span>
                </section>
                <section className="receitas-summary-card receitas-summary-card-pending">
                    <span className="receitas-summary-label">A receber</span>
                    <strong>{formatToBRL(receitas?.valorTotalAReceber)}</strong>
                    <span className="receitas-summary-description">
                        <ScheduleIcon aria-hidden="true" />
                        Valores pendentes
                    </span>
                </section>
            </div>

            <Table params={tableParams} dataArray={receitas?.parcelas || []} errorOccurred={fetchListError} loading={loading}/>
        </div>
    );
}

export default BalancoFinanceiroReceitasTab;
